/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeliverFeeWarehouseStepRespVo
 */
export interface DeliverFeeWarehouseStepRespVo {
    /**
     * 起始值：重量(kg)或CBM，按 tab 的 chargeStandard 判断
     * @type {number}
     * @memberof DeliverFeeWarehouseStepRespVo
     */
    startValue?: number;
    /**
     * 结束值
     * @type {number}
     * @memberof DeliverFeeWarehouseStepRespVo
     */
    endValue?: number;
    /**
     * 步长
     * @type {number}
     * @memberof DeliverFeeWarehouseStepRespVo
     */
    stepValue?: number;
    /**
     * 起始金额
     * @type {number}
     * @memberof DeliverFeeWarehouseStepRespVo
     */
    startAmount?: number;
    /**
     * 每步递增金额
     * @type {number}
     * @memberof DeliverFeeWarehouseStepRespVo
     */
    stepAmount?: number;
}

/**
 * Check if a given object implements the DeliverFeeWarehouseStepRespVo interface.
 */
export function instanceOfDeliverFeeWarehouseStepRespVo(value: object): value is DeliverFeeWarehouseStepRespVo {
    return true;
}

export function DeliverFeeWarehouseStepRespVoFromJSON(json: any): DeliverFeeWarehouseStepRespVo {
    return DeliverFeeWarehouseStepRespVoFromJSONTyped(json, false);
}

export function DeliverFeeWarehouseStepRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliverFeeWarehouseStepRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'startValue': json['startValue'] == null ? undefined : json['startValue'],
        'endValue': json['endValue'] == null ? undefined : json['endValue'],
        'stepValue': json['stepValue'] == null ? undefined : json['stepValue'],
        'startAmount': json['startAmount'] == null ? undefined : json['startAmount'],
        'stepAmount': json['stepAmount'] == null ? undefined : json['stepAmount'],
    };
}

export function DeliverFeeWarehouseStepRespVoToJSON(json: any): DeliverFeeWarehouseStepRespVo {
    return DeliverFeeWarehouseStepRespVoToJSONTyped(json, false);
}

export function DeliverFeeWarehouseStepRespVoToJSONTyped(value?: DeliverFeeWarehouseStepRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startValue': value['startValue'],
        'endValue': value['endValue'],
        'stepValue': value['stepValue'],
        'startAmount': value['startAmount'],
        'stepAmount': value['stepAmount'],
    };
}

